import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-lg text-background-50"></i>
              </span>
              <span className="text-xl font-bold font-heading text-white">汗汗漫画网</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed max-w-sm">
              汗汗漫画网主打<strong>无删减漫画</strong><strong>下拉式免费阅读</strong>，韩国漫画完整版覆盖广泛，下拉观看操作简单，免费为您呈现各类热门韩国漫画的完整故事与细腻画面。
            </p>
            <div className="flex items-center gap-4 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm text-foreground-200"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm text-foreground-200"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm text-foreground-200"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4"><a href="/category/all">快速导航</a></h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页推荐</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">全部分类</Link></li>
              <li><Link to="/category/romance" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">恋爱漫画</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">奇幻漫画</Link></li>
              <li><Link to="/category/action" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">动作漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4"><a href="/about">关于我们</a></h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">品牌介绍</Link></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">联系我们</a></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">帮助中心</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 汗汗漫画网 - 无删减漫画下拉式免费阅读平台。本站所有漫画均来自网络，版权归原作者所有。
          </p>
          <p className="text-xs text-foreground-500 whitespace-nowrap">
            <a href="#" className="hover:text-foreground-300 transition-colors" rel="nofollow">沪ICP备XXXXXXXX号</a>
          </p>
        </div>
      </div>
    </footer>
  );
}